import { defineStore } from "pinia";

export const useStore = defineStore({
  id: "userStore", //ストアの識別子

  persist: true, //このストアの状態を永続化する

  //状態を定義
  state: () => ({
    isLogin: false, //ログイン状態
    authToken: "", //認証トークン
    payload: null,
    tokenHeaders: {},
  }),

  //状態を変更するためのアクション
  actions: {
    setAuthToken(value) {
      this.authToken = value;
    },
    setIsLogin(value) {
      this.isLogin = value;
    },
    setPayload(value) {
      this.payload = value;
    },
    setArticles(articles) {
      this.articles = articles;
    },
    updateArticle(index, article) {
      this.articles.article[index] = article;
    },
    setQuills(value) {
      this.quills = value;
    },
    async logout() {
      this.$reset();
      this.setAuthToken(null);
      this.setIsLogin(false);
      this.setPayload(null);
    },
  },

  //状態から派生した値を取得するためのゲッター
  getters: {
    getAuthToken() {
      return this.authToken;
    },
    getIsLogin() {
      return this.isLogin;
    },
    getPayload() {
      return this.payload;
    },
    getTokenHeaders() {
      if (this.authToken) {
        return {
          headers: {
            Authorization: `Bearer ${this.authToken}`,
          },
        };
      } else {
        return {};
      }
    },
  },
});

/*
//ストアを使用するためのピニアのインスタンスを作成します
export const pinia = createPinia();

pinia.use(
  createPersistedState({
    storage: window.sessionStorage,
    paths: ['isLogin', 'authToken', 'payload'], // 保存したい状態を配列として指定
  })
);*/
